/* soraflo-push: 2026-07-09T05:33:04.826Z */
/**
 * Fitment Auto-Filter — SoraFlo
 *
 * Reads the vehicle saved by the Vehicle Fitment Filter widget (localStorage)
 * and automatically applies it as collection filter URL params on every
 * /collections/ page the shopper visits.
 *
 * Configuration is read from the .vff-af-block element injected by the
 * "Fitment Auto-Filter" theme block, so no hardcoded settings are needed here.
 */

(function () {
  "use strict";

  // ── Only run on collection pages ──────────────────────────────────────────
  if (!/\/collections\//.test(window.location.pathname)) return;

  // ── Respect vehicle filter visibility ─────────────────────────────────────
  // The vehicle filter section emits a hidden #vff-page-state element on every
  // page it is placed on. When data-show="false" the merchant has explicitly
  // hidden the filter for this collection — skip redirecting and the banner.
  // If the element is absent entirely (section not in this template), we
  // proceed normally so the banner still works on pages like /collections/all
  // that may not use the filter section but do use the auto-filter block.
  var pageState = document.getElementById("vff-page-state");
  if (pageState && pageState.getAttribute("data-show") === "false") {
    // The vehicle filter section is on this template but hidden for this collection.
    // Still allow the banner on the results/redirect-target collection (data-is-results="true"),
    // e.g. /collections/all, so shoppers can see what they're filtered to.
    var isResults = pageState.getAttribute("data-is-results") === "true";
    if (!isResults) return;
  }

  // ── Read block config (injected by auto-apply-fitment.liquid) ─────────────
  var block = document.querySelector(".vff-af-block");
  var autoRedirect = !block || block.getAttribute("data-auto-redirect") !== "false";
  var showBanner   = !block || block.getAttribute("data-show-banner")   !== "false";
  var bannerLabel  = (block && block.getAttribute("data-banner-text"))  || "Filtering for";

  // Resolve banner accent colour.
  // Priority order:
  //   1. window.__vffBannerColor  — injected by SoraFlo push into theme.liquid (most reliable)
  //   2. data-accent on the block element — only if it has been set to a non-default value
  //   3. Neutral dark fallback (avoids the ugly #ea580c schema default)
  var rawAccent = block && block.getAttribute("data-accent");
  var accentColor =
    (window.__vffBannerColor && window.__vffBannerColor !== "#ea580c")
      ? window.__vffBannerColor
      : (rawAccent && rawAccent !== "#ea580c")
        ? rawAccent
        : "#1e293b";

  // ── Find the saved vehicle in localStorage ────────────────────────────────
  // The widget saves to vff_{shopDomain}_{namespace} — we scan all vff_* keys
  // so this script needs no knowledge of the namespace used.
  var saved = null;
  var savedKey = null;
  try {
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf("vff_") === 0) {
        var v = null;
        try { v = JSON.parse(localStorage.getItem(k) || "null"); } catch (e) {}
        if (v && v.make) {
          saved    = v;
          savedKey = k;
          break;
        }
      }
    }
  } catch (e) {}

  if (!saved || !saved.make) return;

  // Derive param names — stored by the widget when vehicle is saved.
  // Fall back to the standard Shopify metafield filter convention so older
  // localStorage entries (saved before params were persisted) still work.
  var makeParam  = saved.makeParam  || "filter.p.m.custom.make";
  var modelParam = saved.modelParam || "filter.p.m.custom.model";
  var yearParam  = saved.yearParam  || "filter.p.m.custom.year";

  // ── Check whether filters are already applied (prevents redirect loop) ────
  var currentParams = new URLSearchParams(window.location.search);
  var alreadyFiltered = currentParams.has(makeParam);

  if (alreadyFiltered) {
    // Already filtered — just show the banner so the shopper knows
    if (showBanner) renderBanner(saved, accentColor, bannerLabel, makeParam, modelParam, yearParam, savedKey);
    return;
  }

  if (!autoRedirect) return;

  // ── Build redirect URL ────────────────────────────────────────────────────
  var newParams = new URLSearchParams();

  // Carry forward any non-filter params (sort_by, view, etc.) but drop existing
  // filter.* params to start clean
  currentParams.forEach(function (val, key) {
    if (key.indexOf("filter.") !== 0) newParams.set(key, val);
  });

  newParams.set(makeParam, saved.make);
  // Always include Universal fitment products (mirrors widget submit logic)
  if (saved.make !== "Universal") newParams.append(makeParam, "Universal");
  if (saved.model && modelParam) newParams.set(modelParam, saved.model);
  if (saved.year  && yearParam)  newParams.set(yearParam,  saved.year);

  window.location.replace(window.location.pathname + "?" + newParams.toString());

  // ── Banner renderer ───────────────────────────────────────────────────────

  function renderBanner(vehicle, accent, label, mkParam, mdParam, yrParam, lsKey) {
    var display = vehicle.model || vehicle.make;

    var bar = document.createElement("div");
    bar.className = "vff-af-bar";
    bar.setAttribute("role", "status");
    bar.style.cssText = [
      "display:flex",
      "align-items:center",
      "justify-content:center",
      "gap:0.6em",
      "width:100%",
      "padding:0.6rem var(--px-mobile, 1.5rem)",
      "background:" + accent,
      "color:#fff",
      "font-family:var(--font-body-family,sans-serif)",
      "font-size:0.85rem",
      "font-weight:600",
      "letter-spacing:0.02em",
      "box-sizing:border-box",
      "position:static"
    ].join(";");

    var msg = document.createElement("span");
    msg.textContent = label + ": " + display;

    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.textContent = "Remove";
    removeBtn.style.cssText = [
      "background:rgba(0,0,0,0.25)",
      "border:none",
      "border-radius:3px",
      "color:#fff",
      "font-family:inherit",
      "font-size:0.78rem",
      "font-weight:700",
      "letter-spacing:0.04em",
      "padding:0.2em 0.7em",
      "cursor:pointer",
      "flex-shrink:0",
      "transition:background 0.15s"
    ].join(";");

    removeBtn.addEventListener("mouseover",  function () { removeBtn.style.background = "rgba(0,0,0,0.40)"; });
    removeBtn.addEventListener("mouseout",   function () { removeBtn.style.background = "rgba(0,0,0,0.25)"; });

    removeBtn.addEventListener("click", function () {
      // Clear localStorage
      try { if (lsKey) localStorage.removeItem(lsKey); } catch (e) {}

      // Strip vehicle filter params from URL and reload
      var p = new URLSearchParams(window.location.search);
      p.delete(mkParam);
      if (mdParam) p.delete(mdParam);
      if (yrParam)  p.delete(yrParam);

      var qs = p.toString();
      window.location.replace(window.location.pathname + (qs ? "?" + qs : ""));
    });

    bar.appendChild(msg);
    bar.appendChild(removeBtn);

    // Inject as first child of <main> so it always sits below the sticky header.
    // Remove any existing bar first — multiple script instances (extension CDN
    // version + theme asset version) can both call renderBanner; whichever runs
    // second replaces the first so the final colour is always authoritative.
    var existingBar = document.querySelector(".vff-af-bar");
    if (existingBar && existingBar.parentNode) existingBar.parentNode.removeChild(existingBar);

    var main = document.querySelector("main") || document.querySelector("[role='main']");
    if (main) {
      main.insertBefore(bar, main.firstChild);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }
}());
